import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Text, TouchableOpacity, View } from 'react-native'; // import { TrackerProps } from '../../../utils/tracking';
// import { useComponentTracking } from '../../../hooks/useTracking';

import { OrderListPopup } from '../../OrderListPopup/rn';
import styles from './styles';
export var OrderType;
(function (OrderType) {
  OrderType["food"] = "food";
})(OrderType || (OrderType = {}));
export var ButtonType;
(function (ButtonType) {
  ButtonType[ButtonType["Link"] = 1] = "Link";
  ButtonType[ButtonType["Primary"] = 2] = "Primary";
})(ButtonType || (ButtonType = {}));
export var OrderSelector = function OrderSelector(props) {
  var _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$buttonText = props.buttonText,
    buttonText = _props$buttonText === void 0 ? '' : _props$buttonText,
    panelTitleText = props.panelTitleText,
    showLoading = props.showLoading,
    onLoadMore = props.onLoadMore,
    loadMoreParams = props.loadMoreParams,
    limit = props.limit,
    orderCardType = props.orderCardType,
    onClosePopup = props.onClosePopup,
    groupOrderText = props.groupOrderText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? ButtonType.Link : _props$buttonType,
    propsStyles = props.styles,
    propsButtonStyles = props.buttonStyles; // const {
  //   tracker,
  //   result: { selectorBtn: selectorBtnTracking },
  // } = useComponentTracking({
  //   componentTrackingData,
  //   componentData: { ...props },
  // });

  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var onClickShowOrderBtn = function onClickShowOrderBtn() {
    if (disabled) {
      return;
    }
    if (props !== null && props !== void 0 && props.onPressClickHere) {
      (props === null || props === void 0 ? void 0 : props.onPressClickHere) && (props === null || props === void 0 ? void 0 : props.onPressClickHere());
      return;
    } // selectorBtnTracking?.trackingClick && tracker.click(selectorBtnTracking.trackingClick);

    setShowPopup(true);
  };
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
  };
  var onSelectOrder = function onSelectOrder() {
    setShowPopup(false);
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: [styles.container, buttonType === ButtonType.Primary && styles.largeBorderRadius, propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.containerStyle]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.baseTextStyles, propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.textStyle]
  }, text), /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: propsButtonStyles === null || propsButtonStyles === void 0 ? void 0 : propsButtonStyles.containerStyle,
    onPress: onClickShowOrderBtn
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.baseTextStyles, !disabled && styles.buttonText, !disabled && buttonType === ButtonType.Primary && styles.primaryColor, propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.textStyle, propsButtonStyles === null || propsButtonStyles === void 0 ? void 0 : propsButtonStyles.textStyle]
  }, " ".concat(buttonText)))), /*#__PURE__*/React.createElement(OrderListPopup, {
    active: showPopup,
    panelTitleText: panelTitleText,
    showLoading: showLoading,
    loadMoreParams: loadMoreParams,
    limit: limit,
    onLoadMore: onLoadMore,
    groupOrderText: groupOrderText,
    orderCardType: orderCardType,
    onClosePopup: handleClosePopup,
    onSelectOrder: onSelectOrder // componentTrackingData={componentTrackingData}
  }));
};